import { IconButton, Chip } from "@material-ui/core"
import clsx from "clsx"
import React, { useEffect, useState } from "react"
import { Card } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import SVG from "react-inlinesvg"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router"
import { Link, useHistory } from "react-router-dom"
import { CardBody } from "../../../../../_metronic/_partials/controls/index.js"
import {
  initialFilterTable
} from "../../../../../component/atoms/Tabel/index.jsx"
import { EmptyCard, TableSkeleton } from "../../../../../component/index.jsx"
import { getUrlParsingPageFilter } from "../../../../../config/EndpointCollection.js"
import { ICON_CONSTANTS, ILLUSTRATION_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { PRIVILEGE_ENUM } from "../../../../../constants/PrivilegeConstants.js"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import {
  clearDataFO,
  getKpiGoalThisYearTargetRegional,
  getKpiGoalThisYearTargetSubRegionalList
} from "../../../../../redux/actions/FieldOfficerAction.jsx"
import { stringFormatting, toThousandConvert } from "../../../../helpers/TextHelper.js"
import { useUrlParam } from "../../../../hooks/useUrlParams.jsx"
import { loadUserLogin } from "../../../../service/userManagementAction.js"
import { UNIT_STRING } from "../../../../../constants/StringConstant.js"
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers/AssetsHelpers.js"

export function KPIGoalThisYear({regionalId, year}) {
  const dispatch = useDispatch()
  const { General, FieldOfficer } = useSelector((state) => state)
  const thisYear = year || new Date().getFullYear()
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const [search, setSearch] = useState({ keyword: "" })
  const [isTargetRegionalLoading, setIsTargetRegionalLoading] = useState(true)
  const [queryStringObj, setQueryStringObj] = useState(undefined)
  const urlParams = useUrlParam()
  const [currentParam] = useState({
    ...initialFilterTable
  })
  const privileges = loadUserLogin().privilege
  useEffect(() => {
    dispatch(clearDataFO())
    if (regionalId) {
      dispatch(getKpiGoalThisYearTargetRegional(thisYear, regionalId)).then(() =>
        setIsTargetRegionalLoading(false)
      )
    }
  }, [regionalId])

  useEffect(() => {
    if (queryStringObj?.keyword) {
      setSearch({ keyword: queryStringObj?.keyword })
    }
  }, [queryStringObj])

  useEffect(() => {
    setQueryStringObj(urlParams.getUrlParamsObj)
  }, [urlParams.getUrlParamsObj])

  const selectedMonth = queryStringObj?.month != null && queryStringObj?.month !== "" ? parseInt(queryStringObj.month) : null

  const handleMonthChange = (month) => {
    const urlParam = getUrlParsingPageFilter({
      ...currentParam,
      keyword: search.keyword,
      month: month,
    })
    history.push({ pathname: location.pathname, search: urlParam })
  }

  const fetchQueryParamData = (param) => {
    return dispatch(getKpiGoalThisYearTargetSubRegionalList(thisYear, regionalId, param))
  }

  useEffect(() => {
    const result = location?.search
    if (regionalId) fetchQueryParamData(result)
  }, [location.search, regionalId])

  return (
    <Card>
      <CardBody>
        {!isTargetRegionalLoading ? (
          FieldOfficer?.kpiGoalThisYearTargetRegional ? (
            <>
              <div className="mb-5 pb-5">
                <h2 className="font-weight-bolder text-uppercase">
                  {t("label_regional")} {stringFormatting(FieldOfficer?.kpiGoalThisYearTargetRegional?.regional_name)}, {thisYear}
                </h2>
                <span className="txt-16 font-weight-medium">{t("label_regional_head")}: {stringFormatting(FieldOfficer?.kpiGoalThisYearTargetRegional?.regional_head_name)}</span>
              </div>
              <div className="mb-5 mt-5 d-flex align-items-center justify-content-between">
                <span className="font-weight-bolder txt-16 text-uppercase">{t("label_plant_target_forecast")}</span>
                <Link
                    to={RoutesConstants.FIELD_OFFICER.EDIT_TARGET_REGIONAL(
                      new Date().getFullYear(),
                      regionalId
                    )}>
                    <IconButton disableRipple={true} disableFocusRipple={true}>
                      <img src={ICON_CONSTANTS.EDIT_BLACK} alt="edit" />
                    </IconButton>
                  </Link>
              </div>
              <table className="table-bordered w-100 mb-5">
                <thead>
                  <tr>
                    <th className="py-5 px-3 bg-disabled text-uppercase">{t("label_plant_type")}</th>
                    <th className="py-5 px-3 bg-disabled text-uppercase">{t("label_planting_target_yearly")}</th>
                    <th className="py-5 px-3 bg-disabled text-uppercase">{t("label_forecast_yearly")}</th>
                  </tr>
                </thead>
                <tbody>
                  {(FieldOfficer?.kpiGoalThisYearTargetRegional?.target || []).map((targetItem) => (
                    <tr key={targetItem.plant_type_id}>
                      <td className="py-3 px-3 font-weight-bolder">{stringFormatting(targetItem.plant_type_name)}</td>
                      <td className="py-3 px-3">{stringFormatting(toThousandConvert(targetItem.planting_target), UNIT_STRING.HA)}</td>
                      <td className="py-3 px-3">{stringFormatting(toThousandConvert(targetItem.forecast), UNIT_STRING.HA)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="mb-5 mt-5 d-flex align-items-center justify-content-between">
                <span className="font-weight-bolder txt-16 text-uppercase">{t("label_sub_regional_list")}</span>
                <Link
                  to={RoutesConstants.FIELD_OFFICER.EDIT_TARGET_SUBREGIONAL(
                    new Date().getFullYear(),
                    regionalId
                  )}>
                  <IconButton disableRipple={true} data-test={"button-edit-sub-regional"}>
                    <SVG src={ICON_CONSTANTS.EDIT_BLACK} alt="edit" />
                  </IconButton>
                </Link>
              </div>
              <div className="mb-5 mt-5">
                <div className="d-flex align-items-center">
                  {[
                    { label: "1 Tahun", value: null },
                    { label: "Jan", value: 0 },
                    { label: "Feb", value: 1 },
                    { label: "Mar", value: 2 },
                    { label: "Apr", value: 3 },
                    { label: "Mei", value: 4 },
                    { label: "Jun", value: 5 },
                    { label: "Jul", value: 6 },
                    { label: "Agt", value: 7 },
                    { label: "Sep", value: 8 },
                    { label: "Okt", value: 9 },
                    { label: "Nov", value: 10 },
                    { label: "Des", value: 11 },
                  ].map((item) => (
                    <Chip
                      key={item.label}
                      className={clsx(
                        "chip-selected-multiple-input mr-2 cursor-pointer font-maxxi",
                        selectedMonth === item.value
                          ? "bg-tertiary-light-green text-primary-green border-primary-green"
                          : "bg-neutral-white text-neutral-gray border-neutral-gray"
                      )}
                      size="medium"
                      label={item.label}
                      onClick={() => handleMonthChange(item.value)}
                      style={{
                        borderWidth: 0,
                        border: "solid",
                      }}
                    />
                  ))}
                </div>
              </div>
              {General?.loading ? (
                <TableSkeleton column={5} row={5} />
              ) : (
              <table className="table-bordered w-100 mb-5">
                <thead>
                  <tr>
                    <th className="py-5 px-3 bg-disabled text-uppercase" style={{ width: "30%" }}>{t("label_sub_regional")}</th>
                    <th className="py-5 px-3 bg-disabled text-uppercase">{t("label_plant_type")}</th>
                    {selectedMonth === null && <th className="py-5 px-3 bg-disabled text-uppercase text-center">{t("label_planting_target")}</th>}
                    <th className="py-5 px-3 bg-disabled text-uppercase text-center">{t("dropdown_forecast")}</th>
                    <th className="py-5 px-3 bg-disabled text-uppercase text-center" style={{ width: "100px" }}>{t("label_change_forecast")}</th>
                  </tr>
                </thead>
                <tbody>
                  {(FieldOfficer?.pageData ?? []).map((subRegional) => {
                    const cropData = subRegional.crop_data || []
                    const rowSpan = cropData.length + 1
                    const totalPlantingTarget = cropData.reduce((sum, item) => sum + (item.planting_target || 0), 0)
                    const totalForecast = cropData.reduce((sum, item) => sum + (item.forecast || 0), 0)
                    return (
                      <React.Fragment key={subRegional.id}>
                        {cropData.map((cropItem, idx) => (
                          <tr key={cropItem.id}>
                            {idx === 0 && (
                              <td rowSpan={rowSpan} className="px-3" style={{ verticalAlign: "top" }}>
                                <div className="py-3">
                                  <span className="font-weight-bolder">{stringFormatting(subRegional.sub_regional_name)}</span>
                                  <br />
                                  <span className="text-muted">
                                    {Array.isArray(subRegional.regency_list) ? subRegional.regency_list.join(", ") : ""}
                                  </span>
                                </div>
                              </td>
                            )}
                            <td className="py-3 px-3">{stringFormatting(cropItem.crop_type)}</td>
                            {selectedMonth === null && <td className="py-3 px-3 text-center">{toThousandConvert(cropItem.planting_target)}</td>}
                            <td className="py-3 px-3 text-center">{stringFormatting(toThousandConvert(cropItem.forecast), UNIT_STRING.HA)}</td>
                            {idx === 0 && (
                              <td rowSpan={rowSpan} className="px-3 text-center" style={{ verticalAlign: "middle" }}>
                                {privileges.indexOf(PRIVILEGE_ENUM.DETAIL_FIELD_OFFICER) > -1 && (
                                  <Link
                                    to={RoutesConstants.FIELD_OFFICER.FORECAST_SUBREGIONAL(
                                      subRegional.id,
                                      year,
                                      regionalId
                                    ) + (selectedMonth !== null ? `?month=${selectedMonth}` : "")}>
                                    <div className="btn btn-icon btn-detail btn-hover-secondary btn-md">
                                      <span className={`svg-icon svg-icon-2x svg-icon-primary`}>
                                        <SVG src={toAbsoluteUrl(ICON_CONSTANTS.EDIT_LIST)} />
                                      </span>
                                    </div>
                                  </Link>
                                )}
                              </td>
                            )}
                          </tr>
                        ))}
                        <tr className="font-weight-bolder card-header-bg-gray">
                          <td className="py-3 px-3 text-negative-color-2">Total</td>
                          {selectedMonth === null && <td className="py-3 px-3 text-negative-color-3 text-center">{toThousandConvert(totalPlantingTarget)}</td>}
                          <td className="py-3 px-3 text-negative-color-3 text-center">{stringFormatting(toThousandConvert(totalForecast), UNIT_STRING.HA)}</td>
                        </tr>
                      </React.Fragment>
                    )
                  })}
                </tbody>
              </table>
              )}
            </>
          ) : (
            <EmptyCard
              image={ILLUSTRATION_CONSTANTS.EMPTY_STATE_NO_DATA}
              body={t("messages_response_empty_target_state", { year: thisYear })}
            />
          )
        ) : (
          <></>
        )}
      </CardBody>
    </Card>
  )
}